export default function useLoadingStateClass(isLoading) {
  return `loading-state-element ${isLoading ? 'is-loading' : ''}`;
}
